<template>
  <div id="app">
    <div class="title">
      <img src="@/assets/img/banner.png" height="112" />
    </div>
    <div class="search">
      <div v-if="token">
        <div class="input">
          <input type="text" placeholder="Search ..." v-model="search" @keydown.enter="searchItems()">
        </div>
        <div class="button" @click="searchItems()">
          <font-awesome-icon :icon="['fas', 'search']" />
        </div>
      </div>
    </div>
    <div class="navigation">
      <div v-if="progress" class="progress"></div>
      <div>
        <span><b>Presenter</b></span>
        <span v-if="token"> /
          <router-link to="/days">
            Days
          </router-link>
        </span>
        <span v-if="token & $route.path.match(/^\/days\/[0-9]+/)"> /
          <router-link :to="'/days/' + $route.params.day">
            {{ days.find(day => day.id == $route.params.day).formatted }}
          </router-link>
        </span>
        <!-- <span v-if="$route.path.match(/^\/days\/[0-9]+\/[0-9]+/)"> /
          <router-link :to="'/days/' + $route.params.day + '/' + $route.params.session">
            {{ sessions.find(session => session.id === $route.params.session).title }}
          </router-link>
        </span> -->
        <span v-if="token" class="logout" @click="removeToken()">
          Logout
          <span class="icon">
            <font-awesome-icon :icon="['fad', 'sign-out-alt']" />
          </span>
        </span>
      </div>
    </div>
    <div class="body">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  computed: {
    ...mapState([
      'token',
      'progress',
      'days',
      'sessions'
    ]),
    search: {
      get: function () {
        return this.$store.state.search;
      },
      set: function (value) {
        this.$store.state.search = value;
      },
    }
  },
  methods: {
    ...mapActions(['removeToken', 'searchItems']),
  }
}
</script>

<style lang="scss">
@import "~fontsource-fira-sans/index.css";
@import "~fontsource-fira-sans/400.css";
@import "~fontsource-fira-sans/700.css";
@import "@/assets/scss/bootstrap/bootstrap";
@import '~bootstrap-vue/src/index';

@import "@/assets/scss/app";
.search {
  padding: 7px 16px;
  > div {
    display: flex;
    > div.input {
      > input[type="text"] {
        border: 1px solid lighten($conference-color, 20%);
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        outline: none;
        padding: 4px 8px;
        width: 400px;
      }
    }
    > div.button {
      display: inline-block;
      background: lighten($conference-color, 20%);
      height: 27px;
      padding: 6px 8px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      cursor: pointer;
      color: white;
    }
  }
}
.navigation {
  position: relative;
  > div {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    padding: 13px 16px;
    color: #ffffff;
    > span {
      > a {
        color: #ffffff;
      }
    }
    .logout {
      float: right;
      cursor: pointer;
    }
  }
}
</style>
